import React from 'react';
import { motion } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function PainPoints() {
  const painPoints = ['Llegás al entrenamiento sin saber exactamente qué sesión vas a dar hoy', 'Usás ejercicios pensados para hombres y no terminan de funcionar con las chicas', 'No entendés cómo afecta el ciclo menstrual al rendimiento y a la carga de entrenamiento', 'El 40% de tus jugadoras abandona antes de los 3 meses y no sabés cómo prevenirlo', 'Siempre los mismos 10 ejercicios de siempre porque no tenés más material estructurado', 'No podés justificar un aumento de precio porque no tenés un sistema profesional visible', 'Tenés jugadoras de distintos niveles juntas y el entrenamiento se convierte en un caos', 'Nadie te enseñó a liderar un equipo femenino: motivación, conflictos, vestuario, comunicación'];
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-277">
      <div className="max-w-4xl mx-auto" data-id="element-278">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-2xl md:text-4xl font-black text-center text-navy mb-6 md:mb-12" data-id="element-279">
          Si sos entrenador/a de fútbol femenino en Argentina, esto te va a
          sonar familiar:
        </motion.h2>

        <div className="space-y-3 md:space-y-4 mb-6 md:mb-12" data-id="element-280">
          {painPoints.map((point, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex items-start gap-3 md:gap-4 p-4 md:p-5 bg-red-50 border border-red-100 rounded-xl" data-id="element-281">
              <XCircle className="w-5 h-5 md:w-6 md:h-6 text-red-500 flex-shrink-0 mt-0.5" data-id="element-282" />
              <p className="text-base md:text-lg font-medium text-gray-800" data-id="element-283">
                {point}
              </p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-284">
          <h3 className="text-xl md:text-3xl font-black text-red-600 bg-red-50 inline-block px-6 md:px-8 py-3 md:py-4 rounded-xl border-2 border-red-200" data-id="element-285">
            ¿Cuántas temporadas más vas a improvisar?
          </h3>
        </motion.div>
      </div>
    </section>;
}